import React, { useState, useEffect, useContext, useRef } from 'react';
import { fetchShortenedLinks } from './api';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../AuthProvider';
import '../css/Dashboard.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Chart from 'chart.js/auto';
import { registerables as ChartjsDateAdapter } from 'chartjs-adapter-date-fns';
import axios from 'axios';
import PostForm from './PostForm';
import Footer from './Footer'; 
function Dashboard() {
  const chartRef = useRef(null);
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const [links, setLinks] = useState([]);
  const [detailedView, setDetailedView] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);
  const [copied, setCopied] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dailyData, setDailyData] = useState([]);
  const [dailyUniqueData, setDailyUniqueData] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const data = await fetchShortenedLinks();
        setLinks(data);
      } catch (error) {
        console.error('Failed to fetch links:', error);
      }
    };
    fetchLinks();
  }, []);

  useEffect(() => {
    if (selectedLink) {
      renderChart();
    }
  }, [selectedLink]);

  const DummyChart = ({ linkData }) => {
    useEffect(() => {
      let chartInstance;

      if (linkData && linkData.totalLinkClicksOverTime && linkData.totalLinkClicksOverTime.length > 0) {
        const timestamps = linkData.totalLinkClicksOverTime.map(entry => new Date(entry.timestamp));
        const clickCounts = linkData.totalLinkClicksOverTime.map(entry => entry.clicks);
        const canvas = document.getElementById('dummyChart');
        if (!canvas) return;

        const ctx = canvas.getContext('2d');

        // Destroy the previous chart instance if it exists
        if (chartInstance) {
          chartInstance.destroy();
        }

        chartInstance = new Chart(ctx, {
          type: 'line',
          data: {
            labels: timestamps,
            datasets: [
              {
                label: 'Total Link Clicks Over Time',
                data: clickCounts,
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 2,
                pointRadius: 3,
                pointBackgroundColor: 'rgba(54, 162, 235, 1)',
                tension: 0.4, // Smooth lines
              },
            ],
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: 'top',
              },
            },
            scales: {
              x: {
                type: 'time',
                time: {
                  unit: 'day',
                  displayFormats: {
                    hour: 'MMM d h\A',
                    day: 'MMM d',
                    week: 'll',
                    month: 'MMM yyyy',
                    year: 'yyyy',
                  },
                },
                title: {
                  display: true,
                  text: 'Date',
                },
              },
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Clicks',
                },
              },
            },
          },
        });
      }

      // Cleanup to destroy the chart when the component unmounts
      return () => {
        if (chartInstance) {
          chartInstance.destroy();
        }
      };
    }, [linkData]);

    return (
      <div style={{ position: 'relative', height: '400px', width: '100%' }}>
        <canvas id="dummyChart"></canvas>
      </div>
    );
  };

  const renderChart = () => {
    if (chartRef.current !== null) {
      chartRef.current.destroy();
    }
    const canvas = document.getElementById('linkClicksChart');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const shortUrls = links.map(link => link.shortUrl);
    const clickCounts = links.map(link => link.clicks);

    chartRef.current = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: shortUrls,
        datasets: [
          {
            label: 'Total Link Clicks',
            data: clickCounts,
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
            borderColor: '#fff',
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
        },
      },
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (detailedView && selectedLink) {
          const response = await fetch(`http://localhost:5000/api/charts/${selectedLink.shortUrl}/daily`);
          if (!response.ok) {
            throw new Error('Failed to fetch data');
          }
          const responseData = await response.json();
          setDailyData(responseData.dailyData);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [detailedView, selectedLink]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (detailedView && selectedLink) {
          const response = await fetch(`http://localhost:5000/api/charts/${selectedLink.shortUrl}/dailyUniqueVisitors`);
          if (!response.ok) {
            throw new Error('Failed to fetch data');
          }
          const responseData = await response.json();
          setDailyUniqueData(responseData.dailyUniqueVisitors);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [detailedView, selectedLink]);

  const renderChartByLink = () => {
    if (chartRef.current !== null) {
      chartRef.current.destroy();
    }
    const canvas = document.getElementById('linkClicksChart2');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const dates = dailyData.map(entry => new Date(entry.date));
    const clicksPerDay = dailyData.map(entry => entry.clicks);

    chartRef.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels: dates,
        datasets: [
          {
            label: 'Link Clicks Per Day',
            data: clicksPerDay,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'MMM d',
              },
            },
          },
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  };

  const renderChartByLinkByUniqueVisitors = () => {
    if (dailyUniqueData && dailyUniqueData.length > 0) {
      if (chartRef.current !== null) {
        chartRef.current.destroy();
      }
      const canvas = document.getElementById('linkClicksChart3');
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const dates = dailyUniqueData.map(entry => new Date(entry.date));
      const visitorsPerDay = dailyUniqueData.map(entry => entry.visitors);

      chartRef.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dates,
          datasets: [
            {
              label: 'Link Unique Visitors Per Day',
              data: visitorsPerDay,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM d',
                },
              },
            },
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    }
  };

  useEffect(() => {
    if (dailyData.length > 0) {
      renderChartByLink();
    }
  }, [dailyData]);

  useEffect(() => {
    if (dailyUniqueData.length > 0) {
      renderChartByLinkByUniqueVisitors();
    }
  }, [dailyUniqueData]);

  const handleLinkClick = (link) => {
    setSelectedLink(link);
    setDetailedView(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const copyToClipboard = (shortUrl) => {
    const fullUrl = `${window.location.origin}/${shortUrl}`;
    navigator.clipboard.writeText(fullUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      })
      .catch((error) => {
        console.error('Failed to copy full URL:', error);
      });
  };

  return (
    <div className="dashboard-container">
      <div className="header">
        <h1>Dashboard</h1>

        <div className="toggle-buttons">
          <button className={!detailedView ? 'active' : ''} onClick={() => setDetailedView(false)}>Basic View</button>
          <button className={detailedView ? 'active' : ''} onClick={() => setDetailedView(true)}>Detailed View</button>
        </div>
      </div>

      {detailedView ? (
        <div className="detailed-view">
          <PostForm />
          {selectedLink && (
            <div className="details">
              <div className="chart-container">
                <canvas id="linkClicksChart" width="800" height="400"></canvas>
              </div>
              <div className="chart-container">
                <canvas id="linkClicksChart2" width="800" height="400"></canvas>
              </div>
              <div className="chart-container">
                <canvas id="linkClicksChart3" width="800" height="400"></canvas>
              </div>
              <h6>Visitors by Country:</h6>
              <ul>
                {selectedLink.uniqueVisitors.map((visitor, index) => (
                  <li key={index}>
                    IP: {visitor.ip}, Country: {visitor.country || 'Unknown'}
                  </li>
                ))}
              </ul>
              <h6>Short URL: {window.location.origin}/{selectedLink.shortUrl}</h6>
              <h6>Long URL: {selectedLink.longUrl}</h6>
              <h6>Link Clicks: {selectedLink.clicks}</h6>
              <button onClick={() => copyToClipboard(selectedLink.shortUrl)}>Copy Short URL</button>
              {copied && <span className="copy-message">Link copied to clipboard!</span>}
            </div>
          )}
        </div>
      ) : (
        <div className="basic-view">
          <h6>Welcome to the Dashboard!</h6>
          <ul>
            {links.map((link) => (
              <li key={link._id}>
                <h6>Short URL: {window.location.origin}/{link.shortUrl}</h6>
                <h6>Long URL: {link.longUrl}</h6>
                <h6>Link Clicks: {link.clicks}</h6>
                <button onClick={() => handleLinkClick(link)}>View Details</button>
                <button onClick={() => copyToClipboard(link.shortUrl)} className={copied ? 'copied' : ''}>Copy Short URL</button>
                {copied && <span className="copy-message">Link copied to clipboard!</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>

  );
}

export default Dashboard;
